export default class TaxRate {
	constructor() {
		this.id = null;
		this.taxRate = null;
		this.taxName = null;
	}
}